<script setup lang="ts">
/**
 * UI-kit component
 * Category: Buttons
 * Name: BtnLink
 * FIGMA: https://www.figma.com/design/oRsJUOAucnhxx5aeqy4TRO/APP-admin?node-id=8144-123320&t=Q08xSIR99kih0t0I-4
 */
import type { BtnLinkProps } from '../types/interfaces'

import BtnLinkName from './BtnLinkName.vue'
import BtnLinkId from './BtnLinkId.vue'
import BtnLinkCopy from './BtnLinkCopy.vue'

defineOptions({
  name: 'BtnLink',
})

withDefaults(defineProps<BtnLinkProps>(), {
  linkName: '',
  linkId: '',
  hideCopy: false,
})
</script>

<template>
  <div class="btn-link">
    <BtnLinkName
      :link-name="linkName"
      :link-url="linkUrl"
      :disabled="!linkUrl"
    >
      <template #iconLeft>
        <slot name="iconLeft" />
      </template>
    </BtnLinkName>
    <BtnLinkId
      v-if="linkId"
      :link-id="linkId"
    />
    <BtnLinkCopy
      v-if="linkUrl && !hideCopy"
      :link-url="linkUrl"
    />
  </div>
</template>

<style lang="scss" scoped src="../styles/_btn-link.scss" />
